// Hero Block View Component
// Read-only view of hero section for public portal pages
import React from 'react';

const HeroBlockView = ({ content }) => {
  if (!content?.backgroundImage) {
    return null;
  }

  const getFontFamily = (fontName) => {
    if (!fontName || fontName === 'system') {
      return 'ui-sans-serif, system-ui, sans-serif';
    }
    return `"${fontName}", sans-serif`;
  };

  const getTextPlacementClass = () => {
    let horizontal = '';
    let vertical = '';

    // Horizontal positioning
    switch (content.textPlacement) {
      case 'left': horizontal = 'justify-start pl-8'; break;
      case 'right': horizontal = 'justify-end pr-8'; break;
      default: horizontal = 'justify-center';
    }

    // Vertical positioning
    switch (content.textVertical || 'middle') {
      case 'top': vertical = 'items-start pt-8'; break;
      case 'bottom': vertical = 'items-end pb-8'; break;
      default: vertical = 'items-center';
    }

    return `${vertical} ${horizontal}`;
  };

  const getTextAlignmentClass = () => {
    switch (content.textPlacement) {
      case 'left': return 'text-left';
      case 'right': return 'text-right';
      default: return 'text-center';
    }
  };

  const getTextSizeStyle = () => {
    switch (content.textSize) {
      case 'small': return { fontSize: '1.05rem', lineHeight: '1.25' };
      case 'large': return { fontSize: '1.98rem', lineHeight: '1.25' };
      case 'xlarge': return { fontSize: '2.4rem', lineHeight: '1.15' };
      default: return { fontSize: '1.35rem', lineHeight: '1.25' };
    }
  };

  return (
    <div
      className="h-full relative bg-cover bg-center rounded-b-lg"
      style={{ backgroundImage: `url(${content.backgroundImage})` }}
    >
      {/* Overlay text */}
      <div className={`absolute inset-0 flex ${getTextPlacementClass()}`}>
        {content.overlayText && (
          <div
            className="p-6 rounded-2xl"
            style={{
              backgroundColor: content.textBgEnabled ? `${content.textBgColor}E6` : 'transparent',
              maxWidth: '45%'
            }}
          >
            <style>
              {`
                .hero-text-content p {
                  margin: 0;
                }
                .hero-text-content .ql-align-left {
                  text-align: left;
                }
                .hero-text-content .ql-align-center {
                  text-align: center;
                }
                .hero-text-content .ql-align-right {
                  text-align: right;
                }
                .hero-text-content .ql-align-justify {
                  text-align: justify;
                }
              `}
            </style>
            <div
              className="text-white hero-text-content"
              style={{
                ...getTextSizeStyle(),
                textShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)',
                fontFamily: getFontFamily(content.textFont)
              }}
              dangerouslySetInnerHTML={{ __html: content.overlayText }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default HeroBlockView;
